import * as React from 'react';

const IconInfoCircle = props => (
  <img className="IconInfoCircle"
  {...props} /> 
);

export default IconInfoCircle;
